import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';

import {
  CREATE_AND_JOIN_ORGANIZATION,
  UPDATE_ORGANIZATION_NAME,
  SHARE_ORGANIZATION_WITH_INVESTORS,
} from '@graphql/mutations/organization.mutations';

import {
  ICreateAndJoinOrganizationInput,
  ICreateAndJoinOrganizationResult,
  IUpdateOrganizationNameInput,
  IUpdateOrganizationNameResult,
  IGetOrganizationByShortNameInput,
  IGetOrganizationByShortNameResult,
  IShareOrganizationWithInvestorsInput,
  IShareOrganizationWithInvestorsResult,
} from '@shared/models/organization';
import { GET_ORGANIZATION_BY_SHORT_NAME } from '@graphql/queries/organization.queries';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private apollo: Apollo) {}

  createAndJoinOrganization(
    input: ICreateAndJoinOrganizationInput
  ): Observable<ICreateAndJoinOrganizationResult> {
    return this.apollo
      .mutate({
        mutation: CREATE_AND_JOIN_ORGANIZATION,
        variables: input,
      })
      .pipe(
        map((result) => result.data as ICreateAndJoinOrganizationResult),
        catchError((error) => {
          throw error;
        })
      );
  }

  updateOrganizationName(
    id: string,
    input: IUpdateOrganizationNameInput
  ): Observable<IUpdateOrganizationNameResult> {
    return this.apollo
      .mutate({
        mutation: UPDATE_ORGANIZATION_NAME,
        variables: { id, input: input.input },
      })
      .pipe(
        map((result) => result.data as IUpdateOrganizationNameResult),
        catchError((error) => {
          throw error;
        })
      );
  }

  getOrganizationByShortName(
    input: IGetOrganizationByShortNameInput
  ): Observable<IGetOrganizationByShortNameResult> {
    return this.apollo
      .query({
        query: GET_ORGANIZATION_BY_SHORT_NAME,
        variables: input,
      })
      .pipe(
        map((result) => result.data as IGetOrganizationByShortNameResult),
        catchError((error) => {
          throw error;
        })
      );
  }

  shareOrganizationWithInvestors(
    input: IShareOrganizationWithInvestorsInput
  ): Observable<IShareOrganizationWithInvestorsResult> {
    return this.apollo
      .mutate({
        mutation: SHARE_ORGANIZATION_WITH_INVESTORS,
        variables: input,
      })
      .pipe(
        map((result) => result.data as IShareOrganizationWithInvestorsResult),
        catchError((error) => {
          throw error;
        })
      );
  }
}
